var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.meetingBgStyles),attrs:{"id":"app"}},[_c('headerComponent'),_c('div',{attrs:{"id":"routerView"}},[_c('router-view',{style:({ height: _vm.remainingHeightWithoutTheHeader + 'px' })})],1),_c('modals'),_c('notifications')],1)}
var staticRenderFns = []

export { render, staticRenderFns }